// KhasLogin.js — Halaman login Zona KHAS
import React, { useState } from 'react'
import { login } from './khasAuth'
import './KhasLogin.css'

const LOGIN_PHOTO = 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXzMGImi4iZi7oXu23hV0WGTtDrAzxzdtDe2DsZdujWKZDHsfcYfD32GLLUs-0_OhYXXVOpIBlH8bla3fNRtmT7pXlSR_M9jEZ2ghOE4BtCiyQCkjAs72gZe6D0TODQokEZRAbJ-kD0vXAzBEw7A_X41I9ZgRonIabrCHrBb3EkrQtYH-z6yvRy1qzdCQdIfmAeXTKA_rQV_qkxMwZoP5X0fRbZ5X8oqRG0UGg56qgW3w8CwsleDYPmA'

function KhasLogin({ onLoginSuccess }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPass, setShowPass] = useState(false)
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    if (!username.trim()) { setError('Email atau username wajib diisi'); return }
    if (!password)        { setError('Kata sandi wajib diisi'); return }
    setLoading(true)
    const result = await login(username.trim(), password)
    setLoading(false)
    if (!result.ok) { setError(result.msg); return }
    onLoginSuccess(result.session)
  }

  return (
    <div className="kl-page">

      {/* ── Kiri: Form ── */}
      <div className="kl-left">

        {/* Logo */}
        <div className="kl-logo">
          <img src="/assets/image/Logo_ZonaKhas.png" alt="Zona KHAS"
            style={{ height:48, width:'auto', objectFit:'contain' }} />
        </div>

        {/* Form area */}
        <div className="kl-form-wrap">
          <h1 className="kl-title">Selamat datang</h1>
          <p className="kl-subtitle">
            Masuk ke Portal Pengajuan Zona KHAS KNEKS.<br />
          </p>

          {error && <div className="kl-error">{error}</div>}

          <form className="kl-form" onSubmit={handleSubmit}>

            {/* Email / Username */}
            <div className="kl-field">
              <label className="kl-label">Email atau Username</label>
              <div className="kl-input-wrap">
                <span className="kl-input-icon">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
                <input className="kl-input" type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  placeholder="Masukkan email atau username Anda"
                  autoFocus autoComplete="username" />
              </div>
            </div>

            {/* Password */}
            <div className="kl-field">
              <label className="kl-label">Kata Sandi</label>
              <div className="kl-input-wrap">
                <span className="kl-input-icon">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
                <input className="kl-input"
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Masukkan kata sandi"
                  autoComplete="current-password" />
                <button type="button" className="kl-eye"
                  onClick={() => setShowPass(p => !p)}>
                  <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
                    stroke="currentColor" strokeWidth="1.8">
                    {showPass
                      ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                      : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                    }
                  </svg>
                </button>
              </div>
            </div>

            {/* Submit */}
            <button type="submit" className="kl-submit" disabled={loading}>
              {loading ? 'Memuat...' : 'Masuk'}
            </button>
          </form>

          <a href="/" className="kl-back">Kembali ke website KNEKS</a>
        </div>

        <div className="kl-left-footer">
          © 2026 Komite Nasional Ekonomi dan Keuangan Syariah
        </div>
      </div>

      {/* ── Kanan: Foto + Quote ── */}
      <div className="kl-right">
        <img
          src={LOGIN_PHOTO}
          alt="Zona KHAS"
          className="kl-right-img" />
        <div className="kl-right-overlay" />
        <div className="kl-right-content">
          <div className="kl-right-badge">
            <div className="kl-right-badge-dot" />
            <span>Program Prioritas KNEKS</span>
          </div>
          <p className="kl-right-quote">
            "Membangun kawasan kuliner yang halal, aman, dan sehat untuk Indonesia yang lebih baik."
          </p>
          <p className="kl-right-quote-sub">
            Zona Kuliner Halal, Aman &amp; Sehat · KNEKS 2026
          </p>
        </div>
      </div>

    </div>
  )
}

export default KhasLogin